import { Typography } from '@global-engineering-shared/gweb-material-ui';
import { Link } from 'react-router';

import { getEntityIcon } from 'features/Entity/components/EntityActionBar/utils/getEntityIcon';
import { getEntityTitle } from 'features/Entity/components/EntityActionBar/utils/getEntityTitle';
import useStyles from 'features/EntityDetails/components/EntityDetails/DetailsTitle/DetailsTitle.styles';
import EntityDetail from 'features/EntityDetails/components/EntityDetails/EntityDetail';
import { EntityType } from 'types/entityType';

type DetailsTitleProps = {
  linkLabel: string;
  backLink: string;
  entityType: EntityType;
  entityName: string | null;
  previousEntityName?: string | null;
};

const DetailsTitle = ({
  linkLabel,
  backLink,
  entityType,
  entityName,
  previousEntityName,
}: DetailsTitleProps) => {
  const classes = useStyles();

  return (
    <Typography variant="h2" fontWeight={600} className={classes.root}>
      <Link className={classes.link} to={backLink}>
        {linkLabel}
      </Link>
      <div>/</div>
      {getEntityIcon(entityType)}
      <EntityDetail
        label={`${getEntityTitle(entityType)} Name`}
        value={entityName}
        previousValue={previousEntityName}
        variant="h2"
        showLabel={false}
      />
    </Typography>
  );
};

export default DetailsTitle;
